export default __webpack_public_path__ + "static/media/header.223612d3.less";